import React, { Component } from "react";

export class PhotoModal extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.ClassModal = this;
  }
  render() {
    let { props } = this;
    let { id, title, onClose } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs id={id} title={title} onClose={onClose} {...props}>
        {props.children}
      </AppModalBs>
    );
  }
}

export default PhotoModal;
